import { useTranslation } from "react-i18next";
import { useRouter, createFileRoute } from "@tanstack/react-router";
import { FaChevronLeft } from "react-icons/fa6";
import { css } from "../../../../styled-system/css";
import { Box, VStack } from "../../../../styled-system/jsx";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import { useIngestionProgress } from "../../../modules/workflow-progress-v2/api/useIngestionProgress";
import { IngestionStepper } from "../../../modules/workflow-progress-v2/components/IngestionStepper";
import { PhaseCard } from "../../../modules/workflow-progress-v2/components/PhaseCard";
import { Button } from "../../../components/core/basic/Button";
import Loading from "../../../components/core/blocks/Loading";

const DataStatusPage = () => {
  const { t } = useTranslation(["onboarding"]);
  const router = useRouter();
  const { model, isLoading } = useIngestionProgress();

  return (
    <PageContainer>
      <VStack alignItems="stretch" gap="large" maxWidth="980px" width="100%" marginX="auto" paddingY="large">
        <Button onPress={() => router.history.back()} variant={"link"} fontSize="small">
          <FaChevronLeft size={13} /> {t(($) => $.onboarding["Back to dashboard"])}
        </Button>

        <Box>
          <h1 className={css({ margin: 0, fontSize: "xxlarge", fontWeight: "bold", color: "text.heading" })}>
            {t(($) => $.onboarding["Data status"])}
          </h1>
          <Box fontSize="medium" color="text.secondary" marginTop="2px">
            {t(($) => $.onboarding["Everything we're loading for your account."])}
          </Box>
        </Box>

        {isLoading ?
          <Loading fullPage={false} height="40vh" />
        : <>
            <Box
              backgroundColor="white"
              border="1px solid {colors.border.default}"
              borderRadius="large"
              paddingX="large"
              paddingY="large"
            >
              <IngestionStepper phases={model.phases} />
            </Box>

            <VStack alignItems="stretch" gap="medium">
              {model.phases.map((phase) => (
                <PhaseCard key={phase.key} phase={phase} />
              ))}
            </VStack>
          </>
        }
      </VStack>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/data-status")({
  component: DataStatusPage,
  staticData: { application: "Merchandising" },
});
